import React, { Fragment } from 'react';

function formatValueWhenLessThanZero() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (value < 0) {
    return 0;
  }

  return value;
}

function formatValueWhenExceedsBoundary(value, max) {
  if (max && max < value) {
    return "".concat(max, "+");
  }

  if (value === Infinity) {
    return '∞';
  }

  return value;
}
/**
 * __Format__
 *
 * This component can be used to compose your own badge together, or if you need
 * the badge style formatting somewhere else.
 *
 * - [Examples](https://atlassian.design/components/badge/badge-format/examples)
 * - [Code](https://atlassian.design/components/badge/badge-format/code)
 */


function Format(_ref) {
  var children = _ref.children,
      max = _ref.max;
  var formattedChildren = formatValueWhenLessThanZero(children);
  var formattedMax = formatValueWhenLessThanZero(max);
  return /*#__PURE__*/React.createElement(Fragment, null, formatValueWhenExceedsBoundary(formattedChildren, formattedMax));
}

export default Format;